export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.unposted-bills-report.index`,
        path: `/${prefix}/${pre}/unposted-bills-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.unposted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Unposted Bills report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.unposted-bills-report.index`,
        path: `/${prefix}/${pre}/unposted-bills-report/print`,
        component: () => import('./prints/UnpostedBills.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.unposted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Unposted Bills report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.print.unposted-bill-details.index`,
        path: `/${prefix}/${pre}/unposted-bills-details/print`,
        component: () => import('./prints/UnpostedBillDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.unposted-bills-report.index`,
                PageDescription: "Accounts/Finance Reports: Unposted Bills report",
            },
            print: true,
        },
    },
];